import React, { useEffect, useMemo, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

/**
 * Reusable search + filter UI.
 * - Keeps search term state internally
 * - Resets when the route changes
 * - Emits filtered results to parent via `onResultsChange`
 */
const SearchItem = ({
  data = [],
  searchField = "title",
  placeholder = "Search...",
  onResultsChange,
  wrapSection = true,
}) => {
  const location = useLocation();
  const [searchItem, setSearchItem] = useState("");
  const onResultsChangeRef = useRef(onResultsChange);

  useEffect(() => {
    onResultsChangeRef.current = onResultsChange;
  }, [onResultsChange]);

  useEffect(() => {
    setSearchItem("");
  }, [location.pathname]);

  const filteredData = useMemo(() => {
    const term = searchItem.trim().toLowerCase();
    if (!term) return data;

    const fields = Array.isArray(searchField) ? searchField : [searchField];

    return (data || []).filter((item) => {
      return fields.some((field) => {
        const value = field.split(".").reduce((current, key) => current?.[key], item);
        if (value === null || value === undefined) return false;
        return String(value).toLowerCase().includes(term);
      });
    });
  }, [data, searchField, searchItem]);

  useEffect(() => {
    onResultsChangeRef.current?.({
      searchItem,
      filteredData,
    });
  }, [filteredData, searchItem]);

  const searchFieldContent = (
    <div className="products-search-container">
      <input
        type="text"
        placeholder={placeholder}
        className="products-search-input"
        value={searchItem}
        onChange={(e) => setSearchItem(e.target.value)}
      />
    </div>
  );

  if (!wrapSection) {
    return searchFieldContent;
  }

  return (
    <div className="subscription-section">
      {searchFieldContent}
    </div>
  );
};

export default SearchItem;
